import React from 'react'
// import { initStore } from '../store'
// import { bindActionCreators } from 'redux';
// import withRedux from 'next-redux-wrapper';
import { connect } from 'react-redux';
// import { compose } from 'recompose';
import PropTypes from 'prop-types';

import AppCustomLink from '../../components/Common/AppCustomLink';
// import Link from 'next/link';
import { cdnApi, podcastTypes, firestoreApi } from '../../lib/utils';
import { fetchTopChartsPodcasts, fetchTopChartsEpisodes } from '../../actions';
// import { fetchUserSubscriptions } from '../actions/PodcastActions';

import { NextSeo } from 'next-seo';
// import FireStoreParser from 'firestore-parser';
// import Router from 'next/router';
import TopCharts from '../../components/Common/TopCharts';

// const types = { 'podcasts': '0', 'episodes': '1' };
// export async function getStaticProps({ params }) {
//     // const podcastTypeId = params && params.id;
//     const genreId = 'All'; //.replace('-and-', ' & ');
//     // try {
//     const results = await Promise.all([fetchTopChartsPodcasts(genreId, 1), fetchTopChartsEpisodes(genreId, 1)]);
//     let finalJsonArray = results[0];
//     let finalJsonArrayEpisodes = results[1];
//     return { props: { podcastsArray: finalJsonArray, episodesArray: finalJsonArrayEpisodes, podcastTypeId: genreId } };
//     // } catch {
//     //     throw new Error("Api call didn't return any data.");
//     //     // return { podcastsInfo: {}, podcastTypeId };
//     //     return { props: { categories: [] } };
//     // }
// }

class Browse extends React.Component {
    static async getInitialProps(context) {
        // const podcastTypeId = params && params.id;
        const genreId = '0'; //.replace('-and-', ' & ');
        const type = context.query.type;
        // try {
        const results = await Promise.all([fetchTopChartsPodcasts(genreId, 1), fetchTopChartsEpisodes(genreId, 1)]);
        let finalJsonArray = results[0];
        let finalJsonArrayEpisodes = results[1];
        return { podcastsArray: finalJsonArray, episodesArray: finalJsonArrayEpisodes, podcastTypeId: genreId, type };
        // } catch {
        //     throw new Error("Api call didn't return any data.");
        //     // return { podcastsInfo: {}, podcastTypeId };
        //     return { props: { categories: [] } };
        // }
    }

    constructor(props) {
        super(props);
        // this.state = {
        //   hasMorePodcasts: true, hasMoreEpisodes: true, podcastsArray: props.podcastsArray,
        //   episodesArray: props.episodesArray, boxShadow: '', forceRenderEpisodes: true
        // };
    }

    render() {
        const { podcastTypeId, type } = this.props;
        const { podcastsArray, episodesArray } = this.props;

        const currentPodcastType = podcastTypes.find((el) => el.id == podcastTypeId) || { 'name': '' };

        let titleSEO;
        let descriptionSEO;
        let canonicalSEO;
        console.dir(podcastTypeId);
        if (podcastTypeId == 'All') {
            titleSEO = 'Top Books';
            descriptionSEO = 'Discover the best books to listen to while running, at work or any other time.';
            canonicalSEO = 'https://tedapp.ai/top-charts';
        } else {
            titleSEO = `Top Books: ${currentPodcastType.name}`;
            descriptionSEO = `Discover the best ${currentPodcastType.name} books to listen to while running, at work or any other time.`;
            canonicalSEO = `https://tedapp.ai/top-charts/${podcastTypeId}`;
        }


        return (
            <div>
                <NextSeo
                    title={titleSEO}
                    description={descriptionSEO}
                    canonical={canonicalSEO}
                    openGraph={{
                        title: titleSEO,
                        description: descriptionSEO,
                        type: 'website',
                        locale: 'en_IE',
                        url: canonicalSEO,
                        images: [{
                            url: 'https://tedapp.ai/explore/static/images/home/1.png',
                            alt: 'Best podcast player for all devices - web, ios, android, windows and mac OS',
                            width: 922,
                            height: 1209,
                        }],
                        site_name: 'Accelerated',
                    }}
                    twitter={{
                        handle: '@tedapp',
                        site: '@tedapp',
                        cardType: 'summary',
                    }}
                />

                <TopCharts podcastsArray={podcastsArray} episodesArray={episodesArray} podcastTypeId={podcastTypeId} tabType={type} />
            </div>
        );
    }
}

Browse.propTypes = {
    podcastsArray: PropTypes.array,
    episodesArray: PropTypes.array,
    podcastTypeId: PropTypes.string,
    type: PropTypes.string,
}


export default connect(null, null)(Browse);
